import './sass/style.scss';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './components/app/app';

ReactDOM.render(
    <App />
    , document.getElementById(`root`));
